import Vue from 'vue'
import axios from 'axios'

if (document.getElementById('vue-realisations')) {
  new Vue({
    async asyncData({ params, $http }) {
      const realisations = await $http.$get(`/wp-json/wp/v2/realisation`)
      return { realisations }
    },
    el: '#vue-realisations',
    data() {
      return {
        filters: {
          page: 1,
          per_page: 9
        },
        isLoading: true,
        realisations: [],
        realisation_types: [],
        realisation_sectors: [],
        totalPages: null
      }
    },
    computed: {
      hasMore() {
        return this.totalPages > this.realisations.length;
      }
    },
    created() {
      this.getRealisations()
    },
    mounted() {
      this.getTypes()
      this.getSectors()
    },
    methods: {
      getTypes() {
        axios.request({
          method: 'GET',
          url: "/wp-json/wp/v2/realisation_type",
          params: {
            per_page: 99
          }
        }).then(response => {
          this.realisation_types = response.data
          this.deleteEmptyTypes()
        })
      },
      getSectors() {
        axios.request({
          method: 'GET',
          url: "/wp-json/wp/v2/realisation_sector",
          params: {
            per_page: 99
          }
        }).then(response => {
          this.realisation_sectors = response.data
          this.deleteEmptySectors()
        })
      },
      deleteEmptySectors() {
        this.realisation_sectors = this.realisation_sectors.filter((el) => el.count != 0)
      },
      deleteEmptyTypes() {
        this.realisation_types = this.realisation_types.filter((el) => el.count != 0)
      },
      getRealisations(more = false) {
        this.isLoading = true
        if (this.filters.realisation_sector === '') {
          delete this.filters.realisation_sector
        }
        axios.request({
          method: 'GET',
          url: "/wp-json/wp/v2/realisation",
          params: this.filters
        }).then(response => {
          this.realisations = (more)? this.realisations.concat(response.data) : response.data
          this.totalPages = response.headers['x-wp-total']
          this.isLoading = false
        }).catch((error) => {
          this.errors = Object.assign(this.errors, error.response.data)
        })
      },
      getMoreRealisations() {
        this.filters.page++;
        this.getRealisations(true)
      },
      getSector(sector_id) {
        let sector = this.realisation_sectors.filter((obj) => obj.id === sector_id)[0]['name']
        return sector
      },
      getType(type_id) {
        let type = this.realisation_types.filter((obj) => obj.id === type_id)[0]['name']
        return type
      },
      updateType(type) {
        this.filters.page = 1
        if(type) {
          this.filters.realisation_type = type
        } else {
          delete this.filters.realisation_type
        }
        this.getRealisations()
      }
    }
  })
}
